import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ContentContext = createContext({ firm: null, practiceAreas: [], attorneys: [], loading: true, error: null, refresh: () => {} });

export function useContent() {
  return useContext(ContentContext);
}

export function ContentProvider({ children }) {
  const [state, setState] = useState({ firm: null, practiceAreas: [], attorneys: [], loading: true, error: null });

  const refresh = useCallback(() => {
    setState((s) => ({ ...s, loading: true, error: null }));
    return axios
      .get(`${API}/content`)
      .then(({ data }) => setState({ ...data, loading: false, error: data.firm ? null : "Site content is not available." }))
      .catch(() => setState((s) => ({ ...s, loading: false, error: "Unable to load site content." })));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(() => ({ ...state, refresh }), [state, refresh]);
  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
}
